import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { shallowEqual, useSelector } from "react-redux";
import { LoadingDialog } from "../../../../../_metronic/_partials/controls";

export function SpecificationsLoadingDialog({reduxName}) {

  const intl = useIntl();

  const { isLoading } = useSelector(
    (state) => ({ isLoading: state[reduxName].listLoading }),
    shallowEqual
  );
  useEffect(() => {}, [isLoading]);
  return <LoadingDialog isLoading={isLoading} text={intl.formatMessage({ id: "LOADING" })} />;
}
